module.exports = __webpack_public_path__ + "img/indexHeader.011be29e.png";